import './ActivityType.scss'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { setActivityKey, setSelectedActivityType } from '@/app/redux/actions/activity-creation'
import { ActivityType as IActivityType } from '@/app/models/new-activity-creation-state'
import {
    selectActivityTypeList,
    selectSelectedActivityType,
} from '@/app/redux/selector/activity-creation'
import SectionBox from '../../Layout/SectionBox/SectionBox'

const ActivityType = () => {
    const componentClass = 'smart-new-activity-type'
    const intl = useIntl()
    const dispatch = useDispatch()
    const activityTypeList = useSelector(selectActivityTypeList)
    const selectedActivityType = useSelector(selectSelectedActivityType)
    const isEdit = useSelector((state: any) => state.layoutReducer.modals.props?.isEdit)
    const isClone = useSelector((state: any) => state.layoutReducer.modals.props?.isClone)

    const onActivityType = (activity: IActivityType) => {
        dispatch(setSelectedActivityType(activity))
        dispatch(setActivityKey(activity.key))
    }

    return (
        <div className={componentClass}>
            <SectionBox
                title={intl.formatMessage({
                    id: 'modals.new.activity.type.choose',
                    defaultMessage: 'Choose activity Type',
                })}>
                <div className={`${componentClass}__list-container`}>
                    {activityTypeList.map((activity: IActivityType) => (
                        <div
                            key={activity.key}
                            className={`${componentClass}__item ${
                                selectedActivityType?.key === activity.key ? 'active' : ''
                            } ${
                                (isEdit || isClone) && selectedActivityType?.key !== activity.key
                                    ? 'is-disabled'
                                    : ''
                            }`}
                            onClick={() => onActivityType(activity)}>
                            <div className={`${componentClass}__item--header`}>
                                <div className={`${componentClass}__item--icon`}>
                                    <i className={`cu cu-${activity.icon}`} />
                                </div>
                                <h3>
                                    {intl.formatMessage({
                                        id: `modals.new.activity.type.${activity.key}`,
                                        defaultMessage: activity.key.toString(),
                                    })}
                                </h3>
                            </div>
                            <div className={`${componentClass}__item--description text-mini`}>
                                {intl.formatMessage({
                                    id: `modals.new.activity.type.description.${activity.key}`,
                                    defaultMessage: 'description',
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </SectionBox>
        </div>
    )
}

export default ActivityType
